export default __webpack_public_path__ + "static/media/spaceman@3x.b564ec47.png";